import React from "react";

import Body from "./body";
import Title from "./title";
import TrustPilot from "./trust-pilot/index";
import {
  AvailableCoverTypeOptionTypes,
  MapSupportDescriptionTypes,
} from "../../types/cover-type.type";

const backGroundWithOutImageContent = (
  <>
    <Title />
    <Body />
  </>
);

export const getSupportDescription = (
  selectedAnswer: AvailableCoverTypeOptionTypes,
  showDefaultStaysure?: boolean
): React.JSX.Element => {
  const mapSupportDescription: MapSupportDescriptionTypes = {
    0: showDefaultStaysure ? backGroundWithOutImageContent : <TrustPilot />,
    1: backGroundWithOutImageContent,
    2: backGroundWithOutImageContent,
  };

  return mapSupportDescription[selectedAnswer];
};
